// extracted by mini-css-extract-plugin
export default {"inputList":"StatusWidgetContainer_inputList__wIJLX","statusInputWrap":"StatusWidgetContainer_statusInputWrap__JaDkf"};